export default __webpack_public_path__ + "static/14-notifications-5a3b5543af87aff6e4f7d15a3f855bf7.png";